import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { createApiClient } from './api/client.js'
import { createSession, type KeyValueStorage } from './auth/session.js'
import { createThemeStore } from './ui/theme.js'
import { createWorkspaceStore } from './ui/workspace.js'

const container = document.getElementById('root')
if (container === null) {
  // index.html обязан нести #root: без него монтировать приложение некуда,
  // и это ошибка сборки страницы, а не штатная ситуация.
  throw new Error('Не найден элемент #root — index.html собран неверно.')
}

// localStorage — единственное постоянное хранилище вкладки; сама сессия
// решает, что в нём осядет (refresh-токен, права), а что останется только
// в памяти (токен доступа, FR-ADM-003) — это её ответственность, не эта точка входа.
const browserStorage: KeyValueStorage = {
  get: (key) => window.localStorage.getItem(key),
  set: (key, value) => window.localStorage.setItem(key, value),
  delete: (key) => window.localStorage.removeItem(key),
}

const session = createSession(browserStorage)
// Тема применяется к корню документа сразу при создании хранилища, до
// первой отрисовки: иначе портал успел бы мигнуть светлым тому, кто
// выбрал тёмный (FR-ADM-020).
const theme = createThemeStore(browserStorage, document.documentElement)
// Пустая база — адрес API совпадает с адресом страницы: сервер сам
// отдаёт и оболочку админки, и API (FR-ADM-001).
const client = createApiClient({ baseUrl: '', session, fetcher: fetch })
// Свёрнутая палитра — свойство рабочего места, как и тема: разворачивать
// её при каждом открытии редактора человек не должен (FR-ADM-044).
const workspace = createWorkspaceStore(browserStorage)

createRoot(container).render(
  <App client={client} session={session} theme={theme} workspace={workspace} />,
)
